import React from 'react'
import { Link } from 'react-router-dom'

function AboutTechDigit() {
    return (
        <div className="about-techdigit td-section td-section--about rts-section-gap">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-9">
                        <div className="about-techdigit-inner">
                            <div className="td-section-head td-section-head--left">
                                <p className="td-section-label">About TechDigit Solutions</p>
                                <h2 className="td-section-title">We Built the Company We Wished Existed</h2>
                                <div className="td-title-rule" aria-hidden="true" />
                            </div>
                            <div className="about-content">
                                <p className="disc">
                                    In 2020, four professionals with backgrounds in healthcare IT and operations kept watching the same thing happen: good businesses getting burned by outsourcing partners who overpromised and underdelivered. Sloppy billing. Security is treated as an afterthought. Call centers staffed by agents who clearly didn't understand the industry they were supporting.
                                </p>
                                <p className="disc">
                                    So they built something different.
                                </p>
                                <p className="disc">
                                    TechDigit Solutions started with one US healthcare clinic. Within two months that clinic's denial rate dropped from 18 percent to under 6 percent. Within six months, they handed us their call center operations, too. That first client didn't just become a success story; they became the standard we've measured every engagement against since.
                                </p>
                                <p className="disc">
                                    Today, TechDigit Solutions delivers four services across the United States: medical billing and revenue cycle management for healthcare providers, enterprise cybersecurity for businesses across every industry, call center and customer support outsourcing for any business that communicates with customers and professional long-form content writing for companies and authors who need to build real authority.
                                </p>
                                <p className="disc about-closing">
                                    We are not trying to be the largest outsourcing company in the market. We are trying to be the one you actually trust.
                                </p>
                                <Link to="/about-us" className="rts-btn btn-primary">
                                    → Learn Our Story
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutTechDigit
